/// Format a calendar-date string (yyyy-mm-dd) as written, regardless of the
/// viewer's timezone: both the parse anchor and the formatter are pinned to
/// UTC so the date never shifts across the viewer's midnight.
const DATE_ONLY_FMT = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

export function formatDateOnly(dateString: string | null): string | null {
  if (!dateString) return null;
  // The read model returns full ISO-8601 timestamps for some date fields, so
  // take only the leading YYYY-MM-DD portion before anchoring to UTC. This is a
  // no-op for already date-only strings and avoids an "...ZT00:00:00Z" parse.
  const datePart = dateString.slice(0, 10);
  const parsed = new Date(`${datePart}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) return null;
  return DATE_ONLY_FMT.format(parsed);
}
